import { Icon } from '@acast/decibel';
import { TrashAltSolidGlyph, UploadSolidGlyph } from '@acast/decibel-glyphs';
import classnames from 'classnames';
import T from 'prop-types';
import React, { Component } from 'react';
import FileDropTarget from 'shared/components/file-drop-target';
import MimeTypes from 'shared/helpers/mime-types';

export default class ReplaceableImage extends Component {
  static propTypes = {
    src: T.string,
    onImageReplaced: T.func.isRequired,
    onImageRemoved: T.func.isRequired,
    enabled: T.bool,
    children: T.node,
    enableRemove: T.bool,
  };

  static defaultProps = {
    src: '',
    enabled: true,
    enableRemove: true,
  };

  constructor(props, ...args) {
    super(props, ...args);

    this.state = {
      isDragOver: false,
      isFileNotAllowed: false,
    };
  }

  onDragOver = () => {
    this.setState({ isDragOver: true, isFileNotAllowed: false });
  };

  onDragEnd = () => {
    this.setState({ isDragOver: false, isFileNotAllowed: false });
  };

  onDrop = file => {
    this.setState({ isDragOver: false, isFileNotAllowed: false });
    this.props.onImageReplaced(file);
  };

  onFileNotAllowed = () => {
    this.setState({ isDragOver: false, isFileNotAllowed: true });
  };

  onFileInputChange = evt => {
    const file = evt.target.files[0];
    if (!file) {
      return;
    }
    if (MimeTypes.Image.indexOf(file.type) > -1) {
      this.onDrop(file);
    } else {
      this.setState({ isFileNotAllowed: true });
    }
    if (this.file) {
      this.file.value = '';
    }
  };

  onSelectClick = evt => {
    if (this.file) {
      this.file.click();
    }
    evt.preventDefault();
  };

  onRemoveClick = () => {
    this.props.onImageRemoved();
  };

  getDragOverMessage() {
    if (this.state.isDragOver) {
      return (
        <div className="replaceable-image__message">
          <div className="replaceable-image__message-text">Drop file here to replace</div>
        </div>
      );
    }
    return null;
  }

  getFileNotAllowedMessage() {
    if (this.state.isFileNotAllowed) {
      return (
        <div className="replaceable-image__message">
          <div className="replaceable-image__message-text">Not an image.</div>
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <FileDropTarget
        className={classnames('replaceable-image', {
          'replaceable-image--drag-over': this.state.isDragOver,
          'replaceable-image--disabled': !this.props.enabled,
        })}
        types={['Files']}
        allow={MimeTypes.Image}
        onDragOver={this.onDragOver}
        onDragEnd={this.onDragEnd}
        onDrop={this.onDrop}
        onFileNotAllowed={this.onFileNotAllowed}
      >
        <div
          className="replaceable-image__image"
          style={{
            backgroundImage: `url(${this.props.src})`,
          }}
        >
          <input
            type="file"
            accept={MimeTypes.Image.join(', ')}
            style={{
              display: 'none',
            }}
            onChange={this.onFileInputChange}
            ref={input => {
              this.file = input;
            }}
          />
          <div className="replaceable-image__image__overlay">
            <div className="icons-container">
              <div className="icons">
                <button type="button" onClick={this.onSelectClick}>
                  <Icon glyph={UploadSolidGlyph} size="1em" />
                </button>
                {this.props.enableRemove && (
                  <button type="button" onClick={this.onRemoveClick}>
                    <Icon glyph={TrashAltSolidGlyph} size="1em" />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
        {this.props.children}
        {this.getDragOverMessage()}
        {this.getFileNotAllowedMessage()}
      </FileDropTarget>
    );
  }
}
